// Radha — interface skin: "Business" (Zoho-style) vs "Sanctuary" (devotional).
//
// Two legitimate answers to what an AR tool should look like, and which one is
// right depends on who is in the room — a finance team living in the tables all
// day wants Zoho's density; the devotional identity is the brand. So both ship,
// and the choice is one click rather than a rebuild.
//
// Sets data-skin on <html>, which theme-zoho.css layers on top of the existing
// light/dark resolution. Business is the default.
import React, { useState } from "react";

const KEY = "radha.skin";
export type Skin = "zoho" | "sanctuary";

/** Applied before first paint (see main.tsx) so the skin never flashes. */
export function resolveSkin(): Skin {
  let stored: string | null = null;
  try { stored = localStorage.getItem(KEY); } catch { /* private mode */ }
  const skin: Skin = stored === "sanctuary" ? "sanctuary" : "zoho";
  if (typeof document !== "undefined") document.documentElement.dataset.skin = skin;
  return skin;
}

export function SkinToggle({ className }: { className?: string } = {}) {
  const [skin, setSkin] = useState<Skin>(
    () => (document.documentElement.dataset.skin as Skin) || "zoho",
  );

  const set = (next: Skin) => {
    document.documentElement.dataset.skin = next;
    try { localStorage.setItem(KEY, next); } catch { /* private mode */ }
    setSkin(next);
  };

  const business = skin === "zoho";
  return (
    <button
      onClick={() => set(business ? "sanctuary" : "zoho")}
      title={business ? "Switch to the Sanctuary interface" : "Switch to the Business interface (Zoho-style)"}
      aria-label="Toggle interface style"
      className={className}
      style={{
        border: "1px solid var(--border)", background: "var(--surface)", color: "var(--fg-muted)",
        borderRadius: 9, height: 30, padding: "0 10px", cursor: "pointer", fontSize: 12, lineHeight: 1,
        whiteSpace: "nowrap",
      }}
    >
      {business ? "Business" : "Sanctuary"}
    </button>
  );
}
